import style from './index.module.css'

import React from 'react'

import type { NativeTag } from 'types/track'

import { Flex } from 'components/ds'
import { TagDot } from 'components/search/search-columns/indicators-column/components/tag-dot'
import HighlightedText from 'components/ui/highlighted-text'

import CheckboxRow from '../components/checkbox-row'

type TagsCheckboxProps = {
  tagOptions: NativeTag[]
  onCheckChange: (_checked: string | boolean, _tag: NativeTag) => void
  value?: number[]
  searchValue?: string
}

const TagsCheckbox = ({
  tagOptions,
  onCheckChange,
  value,
  searchValue,
}: TagsCheckboxProps) => {
  return (
    <Flex direction="column" width="100%">
      {tagOptions.map(tag => (
        <CheckboxRow
          key={tag.id}
          checked={value?.includes(tag.id) ?? false}
          onCheckedChange={checked => onCheckChange(checked, tag)}
          onClick={() => onCheckChange(!value?.includes(tag.id), tag)}
          className={style.Checkbox_RowContainer}
        >
          <Flex align="center" gap="2">
            <TagDot tag={tag} />
            <HighlightedText
              text={tag.name}
              highlights={searchValue ? [searchValue] : []}
              customColors={{
                background: 'var(--disco-yellow)',
              }}
            />
          </Flex>
        </CheckboxRow>
      ))}
    </Flex>
  )
}

export default TagsCheckbox
